export default __webpack_public_path__ + "static/media/300_ml.3c583c1a.svg";